import {createContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {NEW_TECHNICAL_ENGAGEMENT_TAB, OPPORTUNITIES_TAB} from "../../../../../../utils/const/createEnvConsts";
import {useQuery} from "react-query";
import {cpx} from "../../../../../../utils/const/query-key";
import apiService from "../../../../../../api/apiService";
import { useLocation } from "react-router-dom";

const StepperContext = createContext();

export function StepperProvider({createCpxEnv, children}) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const { data: isCpx} = useQuery(cpx, () =>
            true
        , {staleTime: Infinity}
    );

    const { data: departmentId } = useQuery(
        'department-id',
        () => apiService.getDepartmentId().then(r => r.data?.departmentId ?? null),
        {
            staleTime: Infinity,
            suspense: true
        }
    );

    let stepNumber = (isCpx && createCpxEnv) ? 2 : 0;
    if(searchParams.get("step")!==undefined && searchParams.get("step") !== null && searchParams.get("step")<3){
        if((searchParams.get("region")!==undefined && searchParams.get("region") !== null)){
            stepNumber = Number(searchParams.get("step"));
        }else{
            // in that case we have step variable but no region so we set the step to 1 - user should choose region first
            stepNumber =1;
        }
    }

    const [activeStep, setActiveStep] = useState(stepNumber);
    const [customerName, setCustomerName] = useState("");
    const [opportunity, setOpportunity] = useState("");
    const [regionSelected, setRegionSelected] = useState("");
    const [switchLabel, setSwitchLabel] = useState("No");
    const [linkTechnicalEngagementTabIndex, setLinkTechnicalEngagementTabIndex] = useState(OPPORTUNITIES_TAB);
    const [linkDemoTabIndex, setLinkDemoTabIndex] = useState(NEW_TECHNICAL_ENGAGEMENT_TAB);
    const [technicalEngagementValue, setTechnicalEngagementValue] = useState({});
    const navigate = useNavigate();
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {

        if (activeStep === 0) { // this will happen when the user cancel the environment creation and go back to the main page
            navigate("/demo-point");
        } else {
            if (activeStep === 1) {
                setCustomerName("");
                setOpportunity("");
                setRegionSelected("");
                setSwitchLabel("No");
                setTechnicalEngagementValue("");
                setLinkTechnicalEngagementTabIndex(OPPORTUNITIES_TAB);
                setLinkDemoTabIndex(NEW_TECHNICAL_ENGAGEMENT_TAB);
            }
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    return (
        <StepperContext.Provider value={{
            activeStep,
            setActiveStep,
            handleNext,
            handleBack,
            customerName,
            setCustomerName,
            opportunity,
            setOpportunity,
            regionSelected,
            setRegionSelected,
            switchLabel,
            setSwitchLabel,
            technicalEngagementValue,
            setTechnicalEngagementValue,
            linkTechnicalEngagementTabIndex,
            setLinkTechnicalEngagementTabIndex,
            linkDemoTabIndex,
            setLinkDemoTabIndex,
            departmentId
        }}>{children}</StepperContext.Provider>
    );
}

export default StepperContext;
